import styled, { css } from 'styled-components';
import themeColors, { baseColors } from 'styles/config/colors';

import type { CalloutOverrides } from '../..';
import { CalloutType } from '../..';

export const Wrapper = styled.span<{
  $dark?: boolean;
  $type: CalloutType;
  $overrides?: Partial<CalloutOverrides>;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: min-content;

  ${({ $dark, $overrides, $type }) => {
    if ($overrides?.iconColor) {
      return css`
        color: ${$overrides.iconColor};
      `;
    }
    switch ($type) {
      case CalloutType.INFO:
        return $dark
          ? css`
              color: ${baseColors.blue['40']};
            `
          : css`
              color: ${themeColors.iconInfo};
            `;
      case CalloutType.ERROR:
        return $dark
          ? css`
              color: ${baseColors.red['40']};
            `
          : css`
              color: ${themeColors.iconDanger};
            `;
      case CalloutType.WARNING:
        return $dark
          ? css`
              color: ${baseColors.yellow['40']};
            `
          : css`
              color: ${themeColors.iconWarning};
            `;
      case CalloutType.SUCCESS:
        return $dark
          ? css`
              color: ${baseColors.green['40']};
            `
          : css`
              color: ${themeColors.iconSuccess};
            `;
    }
  }}
`;
